export default __webpack_public_path__ + "static/silka-regular-webfont-525eb46c4de3099335fabe04cf30c46f.woff2";